import { TeamRole } from '@pkg/types/team'

export const roleToLabel: Record<TeamRole, string> = {
  MEMBER: 'Interviewer (paid)',
  VIEWER: 'View-only (free)',
  ADMIN: 'Admin-interviewer (paid)',
  ADMIN_FREE: 'Admin view-only (free)',
}
